// <manual />
// Extensão manual para CATFIN_TP_MOV - mapeamento tipo de título para grupo semântico
// A Pagar → Custo, Despesa, Imposto, N/A (grupo Despesa)
// A Receber → Receita, N/A (grupo Receita)

import { FIN_TPTITULO } from '@/constants/FIN_TPTITULO'

export const CATFIN_TP_MOV_CUSTOM = {
  /**
   * Retorna as constantes de CATFIN_TP_MOV filtradas pelo tipo de título.
   * @param {string|null} tipoTitulo - Valor da constante FIN_TPTITULO (APagar ou AReceber)
   * @returns {string[]} Array de constantes CATFIN_TP_MOV
   */
  porTipoTitulo: (tipoTitulo) => {
    const map = {
      [FIN_TPTITULO.APagar]: ['CATFIN_TP_MOV1', 'CATFIN_TP_MOV2', 'CATFIN_TP_MOV4', 'CATFIN_TP_MOV5'],
      [FIN_TPTITULO.AReceber]: ['CATFIN_TP_MOV3', 'CATFIN_TP_MOV5']
    }
    return map[tipoTitulo] || []
  }
}
